const ExpiredScreen = ({ logo }) => (
  <div className="flex flex-col text-center space-y-10 items-center justify-center mx-auto max-w-md w-full h-screen px-4">
    <p>This invitation card has been expired. If you are the owner, please activate the invitation card.</p>
    <img src={logo} alt="Logo" className="h-10 mb-4" />
  </div>
);

export default ExpiredScreen;
